import script from "./TitleSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TitleSection.vue?vue&type=script&setup=true&lang=js"

import "./TitleSection.vue?vue&type=style&index=0&id=38594850&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38594850"]])

export default __exports__